export default "__VITE_ASSET__RB_u5I$V__"